import { stringify } from '@angular/compiler/src/util';
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonSlides, IonSegment, IonSegmentButton } from '@ionic/angular';
import { ApiService, APIData } from '../../services/api.service';
import { FuncService } from '../../services/func.service';

@Component({
  selector: 'app-pack-select',
  templateUrl: './pack-select.component.html',
  styleUrls: ['./pack-select.component.scss'],
})
export class PackSelectComponent implements OnInit {

  @ViewChild('slider') slides: IonSlides;

  apiData: APIData;
  packs: any[] = [];
  disablePrevBtn = true;
  disableNextBtn = false;

  filter = '';

  filterTerm: string;

  formData = {
    pack: '',
    bur: '',
    licencePeriod: 0,
    mediaUsages: [],
    territoryUsages: [],
  };

  slideOpts = {
    allowTouchMove: false,
  };

  burDescriptionVisible = false;

  constructor(
    private apiService: ApiService,
    public funcService: FuncService
  ) { }

  ngOnInit() {
    this.fetchData();
  }

  ionViewWillEnter(){
    this.slides.slideTo(0, 0);
  }

  segmentChanged(ev: any) {

  }

  toggleBurDescriptionVisibility() {
    this.burDescriptionVisible = !this.burDescriptionVisible;
  }

  fetchData() {
    this.apiService.fetch().subscribe((data)=> {
      this.apiData = data;

      this.apiData.packs.forEach( (pack) => {
        let p = {
          title: pack.title,
          description: pack.description,
          licencePeriod: null,
          mediaUsages: [],
          territoryUsages: []
        };

        let mediaUsages = pack.mediausages.map(Number);
        p.mediaUsages = this.apiData.mediaUsages.filter((mediaType) => mediaUsages.includes(mediaType.id));

        let territoryUsages = pack.territoryusages.map(Number);
        p.territoryUsages = this.apiData.territoryUsages.filter((territory) => territoryUsages.includes(territory.id));

        p.licencePeriod = this.apiData.licencePeriods.find((licence) => pack.licenceperiod == licence.id);

        this.packs.push(p);
      });
    }, (err)=> {
      console.log(err);
    });
  }

  nextSlide() {
    this.slides.slideNext();
  }

  prevSlide() {
    this.slides.slidePrev();
  }

  doCheck() {
    let prom1 = this.slides.isBeginning();
    let prom2 = this.slides.isEnd();
  
    Promise.all([prom1, prom2]).then((data) => {
      data[0] ? this.disablePrevBtn = true : this.disablePrevBtn = false;
      data[1] ? this.disableNextBtn = true : this.disableNextBtn = false;
    });
  }

  setPack(pack) {
    this.formData.pack = pack.title;

    var licencePeriodIndex = this.apiData.licencePeriods.map(e => e.id).indexOf(pack.licencePeriod.id);
    this.formData.licencePeriod = licencePeriodIndex;

    this.formData.mediaUsages = pack.mediaUsages.map(({ id }) => id);
    this.apiData.mediaUsages.forEach(item => {
      item.selected = (this.formData.mediaUsages.includes(item.id)) ? true : false;
    });
    
    this.formData.territoryUsages = pack.territoryUsages.map(({ id }) => id);
    this.apiData.territoryUsages.forEach(item => {
      item.selected = (this.formData.territoryUsages.includes(item.id)) ? true : false;
    });
    
    this.nextSlide();
  }

}
